import React, { useCallback } from 'react'
import { Typography } from '@mui/material'

import Timer from '../timer'

interface Props {
  submitText: string
  cooldownText: string
  cooldownDuration: number
  onPress: () => Promise<boolean>
}

const Resend: React.FC<Props> = ({
  submitText,
  cooldownText,
  cooldownDuration,
  onPress: onPressCallback,
}) => {
  const [isCooldown, setIsCooldown] = React.useState(true)

  const onPress = useCallback(() => {
    onPressCallback()
      .then(sent => {
        setIsCooldown(sent)
      })
      .catch(e => {
        console.error(e)
        setIsCooldown(false)
      })
  }, [onPressCallback])

  if (isCooldown) {
    return (
      <Typography component='p' color='rgba(42, 52, 72, 0.45)'>
        {cooldownText}{' '}
        <Timer
          duration={cooldownDuration}
          onFinish={() => setIsCooldown(false)}
        />
      </Typography>
    )
  }

  return (
    <div onClick={onPress}>
      <Typography 
        component='p' 
        color="#304497"
        style={{cursor: 'pointer'}}
        >
          {submitText}
      </Typography>
    </div>
  )
}

export default Resend